(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pranaon-closing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-po-scroll-buy]');
    if (!link) return;
    e.preventDefault();
    var target = document.querySelector('.po-hp') || document.body;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pranaon-hydrate-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('po-hydrate-product')) return;

    class PoHydrateProduct extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        var data = this.querySelector('[data-po-variants]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.form = this.querySelector('form.po-hp__form');
        if (!this.form) return;

        this.idInput = this.form.querySelector('[data-po-id]');
        this.qtyInput = this.form.querySelector('[data-po-qty-input]');
        this.atc = this.form.querySelector('[data-po-atc]');
        this.atcLabel = this.form.querySelector('[data-po-atc-label]');
        this.errorEl = this.querySelector('[data-po-error]');
        this.thumbWrap = this.querySelector('[data-po-thumbs]');
        this.stage = this.querySelector('[data-po-stage]');

        var self = this;

        this.querySelectorAll('[data-po-thumb]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.showMedia(btn.getAttribute('data-po-thumb')); });
        });

        this.querySelectorAll('[data-po-variant]').forEach(function (btn) {
          btn.addEventListener('click', function () { self.selectVariant(Number(btn.getAttribute('data-po-variant'))); });
        });

        this.querySelectorAll('[data-po-qty]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var step = btn.getAttribute('data-po-qty') === 'plus' ? 1 : -1;
            self.setQty(self.getQty() + step);
          });
        });
        if (this.qtyInput) {
          this.qtyInput.addEventListener('change', function () { self.setQty(self.getQty()); });
        }

        this.form.addEventListener('submit', function (e) { self.onSubmit(e); });

        // Swipe between images on touch screens
        if (this.stage) {
          var startX = null;
          this.stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
          this.stage.addEventListener('touchend', function (e) {
            if (startX === null) return;
            var dx = e.changedTouches[0].clientX - startX;
            startX = null;
            if (Math.abs(dx) > 40) self.stepMedia(dx < 0 ? 1 : -1);
          });
        }
      }

      currentVariant() {
        var id = Number(this.idInput.value);
        return this.variants.find(function (v) { return v.id === id; }) || this.variants[0];
      }

      mediaIds() {
        return Array.prototype.map.call(this.querySelectorAll('[data-po-slide]'), function (s) {
          return s.getAttribute('data-po-slide');
        });
      }

      showMedia(id) {
        id = String(id);
        var slides = this.querySelectorAll('[data-po-slide]');
        var found = false;
        slides.forEach(function (s) { if (s.getAttribute('data-po-slide') === id) found = true; });
        if (!found) return;
        slides.forEach(function (s) { s.hidden = s.getAttribute('data-po-slide') !== id; });
        var wrap = this.thumbWrap;
        this.querySelectorAll('[data-po-thumb]').forEach(function (t) {
          var on = t.getAttribute('data-po-thumb') === id;
          t.setAttribute('aria-current', on ? 'true' : 'false');
          if (on && wrap) {
            wrap.scrollTo({
              left: t.offsetLeft - wrap.clientWidth / 2 + t.clientWidth / 2,
              top: t.offsetTop - wrap.clientHeight / 2 + t.clientHeight / 2,
              behavior: 'smooth'
            });
          }
        });
      }

      stepMedia(dir) {
        var ids = this.mediaIds();
        if (ids.length < 2) return;
        var current = this.querySelector('[data-po-slide]:not([hidden])');
        var i = current ? ids.indexOf(current.getAttribute('data-po-slide')) : 0;
        this.showMedia(ids[(i + dir + ids.length) % ids.length]);
      }

      selectVariant(id) {
        var v = this.variants.find(function (x) { return x.id === id; });
        if (!v) return;
        this.idInput.value = v.id;

        this.querySelectorAll('[data-po-variant]').forEach(function (b) {
          b.setAttribute('aria-pressed', Number(b.getAttribute('data-po-variant')) === id ? 'true' : 'false');
        });

        var now = this.querySelector('[data-po-price-now]');
        var was = this.querySelector('[data-po-price-was]');
        if (now) now.innerHTML = v.price;
        if (was) {
          was.innerHTML = v.compare || '';
          was.hidden = !v.compare;
        }

        var flavour = this.querySelector('[data-po-flavour-dynamic]');
        if (flavour) flavour.textContent = v.title;

        this.atc.disabled = !v.available;
        this.atcLabel.textContent = v.available ? this.dataset.atcLabel : this.dataset.soldoutLabel;

        if (v.media) this.showMedia(v.media);
        this.setQty(this.getQty());
        this.hideError();

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      getQty() {
        var n = parseInt(this.qtyInput.value, 10);
        return isNaN(n) ? 1 : n;
      }

      setQty(n) {
        var v = this.currentVariant();
        var max = v && v.max !== null && v.max > 0 ? v.max : 99;
        this.qtyInput.value = Math.min(Math.max(1, n), max);
      }

      showError(msg) {
        if (!this.errorEl) return;
        this.errorEl.textContent = msg;
        this.errorEl.hidden = false;
      }

      hideError() {
        if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; }
      }

      onSubmit(e) {
        if (this.dataset.cartBehaviour === 'page') return; // normal Shopify form post → /cart
        e.preventDefault();
        if (this.atc.disabled || this.atc.getAttribute('aria-busy') === 'true') return;
        this.addToCart();
      }

      addToCart() {
        var self = this;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var nativeDrawer = drawer && typeof drawer.renderContents === 'function';

        var body = { id: Number(this.idInput.value), quantity: this.getQty() };
        if (nativeDrawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }

        this.hideError();
        this.atc.setAttribute('aria-busy', 'true');
        var label = this.atcLabel.textContent;
        this.atcLabel.textContent = 'Adding…';

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
          .then(function (r) {
            if (!r.ok || r.json.status) {
              self.showError(r.json.description || r.json.message || 'Sorry, that couldn’t be added to your cart.');
              return;
            }
            if (nativeDrawer) {
              if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
              drawer.renderContents(r.json);
              return;
            }
            return self.refreshThemeCart(r.json);
          })
          .catch(function () {
            // If anything unexpected happens, fall back to Shopify's normal add-to-cart.
            self.form.submit();
          })
          .finally(function () {
            self.atc.removeAttribute('aria-busy');
            self.atcLabel.textContent = label;
          });
      }

      // Built for Impulse (Archetype Themes) v7: its cart drawer (#CartDrawer) listens for
      // 'ajaxProduct:added' on document, rebuilds the cart and slides open.
      refreshThemeCart(item) {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var self = this;
        var cartDrawer = document.getElementById('CartDrawer');

        // No drawer on the page (e.g. theme set to cart page) → go to the cart.
        if (!cartDrawer) {
          window.location.href = root + 'cart';
          return Promise.resolve();
        }

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: item, addToCartBtn: self.atc }
        }));

        return new Promise(function (resolve) { setTimeout(resolve, 500); }).then(function () {
          var isOpen = cartDrawer.classList.contains('drawer--is-open') ||
            document.documentElement.classList.contains('js-drawer-open');
          if (isOpen) return;

          // Backup: rebuild the cart, then open it with the header cart icon.
          document.dispatchEvent(new CustomEvent('cart:build'));
          var toggle = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
          if (toggle) {
            toggle.click();
          } else {
            window.location.href = root + 'cart';
          }
        });
      }
    }

    customElements.define('po-hydrate-product', PoHydrateProduct);
  })();

  } catch(e) { console.error(e); }
})();
})();
